/**
 * @name 컬러색상
 * @description
 */

/*===================================================================[컬러값] */
export const COLOR = {
  TRANSPARENT: 'TRANSPARENT',
  /**------------------------------------[사용되는컬러] */
  white: '#FFFFFF',
  gs10: '#183B56',
  gs20: '#3D4D5A',
  gs30: '#5A7184',
  gs40: '#B3BAC5',
  gs50: '#E8EBEE',
  gs60: '#EFF1F3',
  gs70: '#F7F8F9',
  /**------------------------------------[BLACK] */
  BLACK: '#000000',

  BLACK1: '#080808',
  BLACK2: '#202020',
  BLACK3: '#373737',
  /**------------------------------------[GRAY] */
  gray10: '#080808',
  gray20: '#202020',
  gray30: '#373737',
  gray40: '#5F5F5F',
  gray50: '#8A8A8A',
  gray60: '#B2B2B2',
  gray70: '#D8D8D8',
  gray80: '#E9E9E9',
  gray90: '#F4F4F4',

  GRAY1: '#5F5F5F',
  GRAY2: '#8A8A8A',
  GRAY3: '#B2B2B2',
  GRAY4: '#D8D8D8',
  GRAY5: '#EAEAEA',
  GRAY6: '#F4F4F4',
  /**------------------------------------[BLUEGRAY] */
  BLUE_GRAY1: '#363849',
  BLUE_GRAY2: '#474A62',
  BLUE_GRAY3: '#525678',
  BLUE_GRAY4: '#677196',
  BLUE_GRAY5: '#7D86A9',
  BLUE_GRAY6: '#959CB8',
  BLUE_GRAY7: '#A9AEC6',
  BLUE_GRAY8: '#CBCEE0',
  BLUE_GRAY9: '#F6FAFF',
  /**------------------------------------[BLUE] */
  blue10: '#3F598A',
  blue20: '#1850DD',
  blue30: '#4073F4',
  blue40: '#ECEEF3',
  blue50: '#E8EDFC',
  blue60: '#ECF1FE',
  blue70: '#BED0F5',
  blue80: '#BED0F5',
  blue90: '#E9F0FE',
  blue100: '#F7FAFF',
  //
  BLUE0: '#0F3FB7',
  BLUE1: '#1146CB',
  BLUE2: '#1850DD',
  BLUE3: '#2B64F5',
  BLUE4: '#4073F4',
  BLUE5: '#6690FB',
  BLUE6: '#82A5ED',
  BLUE7: '#BED0F5',
  BLUE8: '#D6E2FB',
  BLUE9: '#E9F0FE',
  /**------------------------------------[YELLOW] */
  yellow10: '#F6AE3F',
  yellow20: '#EBA12F',
  yellow30: '#F1A93A',
  yellow40: '#F6AE3F',
  yellow50: '#FDC061',
  yellow60: '#FFCF86',
  yellow70: '#FBE4C1',
  yellow80: '#FBECD6',
  yellow90: '#FFF3E1',
  yellow100: '#FEF7EC',
  //
  YELLOW1: '#FDC061',
  YELLOW2: '#F6AE3F',
  YELLOW3: '#EBA12F',
  /**------------------------------------[RED] */
  red10: '#FF5B5C',
  red20: '#F44142',
  red30: '#FF4B4D',
  red40: '#FF5B5C',
  red50: '#FF6D6E',
  red60: '#FF8686',
  red70: '#FCC4C4',
  red80: '#FBD6D6',
  red90: '#FFEAEA',
  red100: '#FFEFEF',
  //
  RED1: '#FF6D6E',
  RED2: '#FF5B5C',
  RED3: '#F44142',
  RED4: '#F2BDBD',
  RED5: '#FFEAEA',
  /**------------------------------------[GREEN] */
  green10: '#40C997',
  green20: '#1EBB82',
  green30: '#2CC28C',
  green40: '#40C997',
  green50: '#6CD5AF',
  green60: '#8DE8CC',
  green70: '#BDF0E4',
  green80: '#CEF8F0',
  green90: '#E2FEF6',
  green100: '#ECFAF5',
  //
  GREEN1: '#6CD5AF',
  GREEN2: '#40C997',
  GREEN3: '#1EBB82',
}

/*===================================================================[테마설정] */

export const FONT = {
  MAIN: 'Pretendard',
}
